import { NotasVersaoListSearchComponent } from './NotasVersaoListSearchComponent'
import { NotasVersaoListToolbar } from './NotasVersaoListToolbar'

export const NotasVersaoListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <NotasVersaoListSearchComponent actions={<NotasVersaoListToolbar />} />
  </div>
)
